export const ValuesContract = [
  {
    title: "Campos clave y ejemplo de valores para un contrato de tokenización inmobiliaria",
    value: `
Los siguientes campos y valores corresponden al **formato estándar que encontrarás en el PDF de ejemplo** [Real-estate+Asset+Contract+Example.pdf](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/Real-estate+Asset+Contract+Example.pdf).  
Rellena cada campo con los datos reales de tu propio activo antes de integrarlos a tu contrato inteligente o compartir el documento con inversionistas.

---

| Campo                                 | Valor / Ejemplo                                                        |
|----------------------------------------|-----------------------------------------------------------------------|
| **Descripción**                        | Propiedad en alquiler, casa de 4 habitaciones                         |
| **Dirección de la propiedad**          | Toronto, Canadá ([Ver en Google Maps](#))                             |
| **Ingreso neto anual**                 | $24,000 CAD                                                           |
| **Prueba de título**                   | Registro de escritura #0001990 ([Enlace a registro](#))               |
| **Certificado de seguro**              | ABC Insurance #0002018 ([Enlace al certificado](#))                   |
| **Nombre(s) y dirección(es) del propietario(s)** | Propietario original                                           |
| **Precio de compra**                   | $500,000 CAD                                                          |
| **Fecha de compra**                    | 1 de julio de 1990                                                    |
| **Valor actual (noviembre 2018)**      | $1,000,000 CAD                                                        |
| **Certificado de tasación**            | [Enlace al certificado](#)                                            |
| **Perfil del propietario**             | [Perfil de LinkedIn](#)                                               |
| **Certificado de notarización**        | [Enlace a la notarización](#)                                         |
| **Nombre del token**                   | MyRealToken                                                           |
| **Valor por token**                    | Cada token representa 0.0001% del activo total                        |
| **Precio inicial del token**           | 300 MyRealTokens = 1 ETH                                              |
| **Distribución total de tokens**       | 1,000,000 tokens                                                      |
| **Dividendos**                         | No aplica                                                             |
| **Derechos de voto**                   | No aplica                                                             |
| **Fecha de emisión**                   | 1 de noviembre de 2018                                                |
| **Firma del propietario**              | _________                                                             |

---

**Recomendación:**  
Completa cada uno de estos campos con información real y verificable de tu activo.  
Incluye enlaces siempre que sea posible para aumentar la transparencia y confianza de los inversionistas.

Esta estructura es ideal como base para la documentación legal y técnica de tu proyecto de tokenización.
`
  }
];

export default ValuesContract;
